var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "tenders-modal",
      attrs: {
        printButton: "",
        downloadButton: "",
        close: _vm.closeModal,
        printStyle: _vm.printStyle,
        title: _vm.title,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "tenders-modal__header",
          attrs: { slot: "modalHeader" },
          slot: "modalHeader",
        },
        [
          _c("i", { staticClass: "uk-icon-gavel" }),
          _vm._v("\n        Тендеры за " + _vm._s(_vm.currentYear) + "\n    "),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tenders-modal__content tenders-content",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          _vm.isLoading ? _c("loading", { staticClass: "loading" }) : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading
            ? [
                _c(
                  "div",
                  { staticClass: "tenders-content__chart" },
                  [
                    _vm.chartData
                      ? _c("pie-modal-chart", {
                          attrs: { data: _vm.chartData },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "tenders-content__list" },
                      _vm._l(_vm.tendersList, function (t, i) {
                        return _c("tenders-list-item", {
                          key: i,
                          attrs: { tender: t, type: _vm.currentType },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal__footer footer",
          attrs: { slot: "modalFooter" },
          slot: "modalFooter",
        },
        [
          _vm.pagination && _vm.pagination.pages_count > 1
            ? _c("old-pagination", {
                staticClass: "footer__pagination",
                attrs: {
                  getNewContent: _vm.changePageHandler,
                  paginationObj: _vm.pagination,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }